import { constructEnum } from '@/lib/enum';

export default constructEnum('LikeScore', {
  LIKE: 1,
  UNLIKE: -1
});
